import { createSelector } from 'reselect';

import { NAME } from './constants';

export const getModel = (state) => state[NAME];

export const getInitialValues = createSelector(
    getModel,
    (model) => model.initialValues,
);

export const getSession = createSelector(getModel, (model) => model.session);

export const getIsLoadingSession = createSelector(
    getSession,
    (session) => session.isLoading,
);

export const getErrorsLogin = createSelector(
    getSession,
    (session) => session.errors,
);

export const getValidPassword = createSelector(
    getModel,
    (model) => model.validPassword,
);

export const getPosts = createSelector(getModel, (model) => model.posts);

export const getPostsData = createSelector(getPosts, (posts) =>
    posts.data.map((item) => {
        return item;
    }),
);

export const getFetchPostsError = createSelector(
    getModel,
    (model) => model.posts.error,
);

export const getPostsIsEmpty = createSelector(
    getPosts,
    (posts) => posts.isEmpty,
);
